/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Qr_TitleInputs */

const vi_cdo_qr_title = /** @type {(inputs: Cdo_Qr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã QR phiếu giao`)
};

/**

* @param {Cdo_Qr_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_qr_title = /** @type {((inputs?: Cdo_Qr_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Qr_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_qr_title(inputs)
});